module.exports = __webpack_public_path__ + "img/icon_submenu17.414a975a.svg";